import React, { useState } from 'react';
import { FiChevronDown } from "react-icons/fi";

const footerSections = [
    {
        title: "CHI SIAMO",
        links: [
            { label: "La nostra storia", href: "https://www.psicopatici.com/about-us" },
            { label: "Dicono di noi", href: "https://www.psicopatici.com/press" },
            { label: "Novità", href: "https://www.psicopatici.com/news" }
        ]
    },
    {
        title: "ASSISTENZA",
        links: [
            { label: "Contatti e supporto", href: "https://www.psicopatici.com/contact-us" },
            { label: "FaQs", href: "https://www.psicopatici.com/faqs" },
            { label: "Sizeyou", href: "https://www.psicopatici.com/size-you-info-page" }
        ]
    },
    {
        title: "IL NOSTRO STORE",
        links: [
            { label: "Donna", href: "https://www.psicopatici.com/product-categories/donna" },
            { label: "Uomo", href: "https://www.psicopatici.com/product-categories/uomo" },
            { label: "Unisex", href: "https://www.psicopatici.com/product-categories/unisex" },
            { label: "Bestseller", href: "https://www.psicopatici.com/product-categories/bestseller" },
            { label: "Collezione SS26", href: "https://www.psicopatici.com/product-categories/nuovi-arrivi" },
            { label: "Gift Card", href: "https://www.psicopatici.com/gift-card" }
        ]
    },
    {
        title: "INFORMAZIONI LEGALI",
        links: [
            { label: "Termini e condizioni", href: "https://legal.psicopatici.com/terms-and-conditions" },
            { label: "Cookie Policy", href: "https://legal.psicopatici.com/cookie-policy" },
            { label: "Privacy Policy", href: "https://legal.psicopatici.com/privacy-policy" },
            { label: "Politica di rimborso", href: "https://legal.psicopatici.com/terms-and-conditions#art-9" }
        ]
    },
    {
        title: "PROGRAMMI",
        links: [
            { label: "Partner Content creator", href: "https://partner.psicopatici.com/" },
            { label: "Partner Negozi", href: "https://partner.psicopatici.com/totemtouch" }
        ]
    }
];

const socialLinks = [
    { label: "Facebook", href: "https://www.facebook.com/psicopaticiitalia/" },
    { label: "Instagram", href: "https://www.instagram.com/psicopaticiitalia/" },
    { label: "TikTok", href: "https://www.tiktok.com/@psicopaticiitalia" },
    { label: "LinkedIn", href: "https://www.linkedin.com/company/psicopaticiitalia" }
];

function Footer() {
    const currentYear = new Date().getFullYear();

    // Su mobile ogni sezione è un accordion; su desktop sono sempre aperte
    const [openSections, setOpenSections] = useState([]);

    const toggleSection = (title) => {
        setOpenSections((prev) =>
            prev.includes(title) ? prev.filter((t) => t !== title) : [...prev, title]
        );
    };

    return (
        <>
            <style>{`
                .psi-footer {
                    width: 100%;
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                    background-color: #f4f4f4;
                    color: #000000;
                    padding: 44px 20px 56px;
                }

                .psi-footer-grid {
                    display: grid;
                    gap: 36px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    padding-bottom: 44px;
                }

                .psi-footer-logo {
                    display: block;
                    height: 26px;
                    width: auto;
                    margin: 0 auto 16px;
                }

                .psi-footer-col {
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    padding-bottom: 14px;
                    text-align: left;
                }

                .psi-footer-col h4 {
                    margin: 0;
                    padding: 0;
                }

                .psi-footer-toggle {
                    display: flex;
                    width: 100%;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 8px;
                    margin: 0;
                    padding: 4px 0;
                    border: 0;
                    background: transparent;
                    font-family: inherit;
                    font-size: 9px;
                    font-weight: 800;
                    line-height: 1.4;
                    text-align: left;
                    text-transform: uppercase;
                    letter-spacing: 0.12em;
                    color: rgba(0, 0, 0, 0.5);
                }

                .psi-footer-chevron {
                    margin-left: auto;
                    font-size: 12px;
                    transition: transform 0.2s ease;
                }

                .psi-footer-chevron.is-open {
                    transform: rotate(180deg);
                }

                .psi-footer-list {
                    display: none;
                    list-style: none;
                    margin: 0;
                    padding: 14px 0 0;
                    text-indent: 0;
                }

                .psi-footer-list li {
                    margin: 0 0 9px;
                    padding: 0;
                    list-style: none;
                    line-height: 1.4;
                }

                .psi-footer-list li:last-child {
                    margin-bottom: 0;
                }

                .psi-footer-link {
                    display: inline-block;
                    font-family: inherit;
                    font-size: 12px;
                    line-height: 1.4;
                    color: rgba(0, 0, 0, 0.6);
                    text-decoration: none;
                    transition: color 0.2s ease;
                }

                .psi-footer-link:hover {
                    color: #000000;
                }

                .psi-footer-bottom {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-between;
                    gap: 16px;
                    padding: 18px 0;
                }

                .psi-footer-copy {
                    margin: 0;
                    font-size: 10px;
                    line-height: 20px;
                    letter-spacing: 0.04em;
                    color: rgba(0, 0, 0, 0.4);
                }

                .psi-footer-copy a {
                    color: rgba(0, 0, 0, 0.4);
                    text-decoration: none;
                    transition: color 0.2s ease;
                }

                .psi-footer-copy a:hover {
                    color: #000000;
                }

                .psi-footer-social {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px 18px;
                }

                .psi-footer-social a {
                    font-size: 10px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.15em;
                    color: rgba(0, 0, 0, 0.45);
                    text-decoration: none;
                    transition: color 0.2s ease;
                }

                .psi-footer-social a:hover {
                    color: #000000;
                }

                @media (min-width: 640px) {
                    .psi-footer {
                        padding-bottom: 64px;
                    }

                    .psi-footer-grid {
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                    }

                    .psi-footer-brand {
                        grid-column: span 2;
                    }

                    .psi-footer-logo {
                        margin-left: 0;
                        margin-right: auto;
                    }
                }

                @media (min-width: 768px) {
                    .psi-footer {
                        padding-left: 40px;
                        padding-right: 40px;
                        padding-top: 60px;
                    }

                    .psi-footer-bottom {
                        flex-direction: row;
                        align-items: center;
                    }
                }

                @media (min-width: 1024px) {
                    .psi-footer {
                        padding-bottom: 0;
                    }

                    .psi-footer-grid {
                        grid-template-columns: 1.4fr repeat(5, minmax(0, 1fr));
                    }

                    .psi-footer-brand {
                        grid-column: span 1;
                    }

                    .psi-footer-col {
                        border-bottom: 0;
                        padding-bottom: 0;
                    }

                    .psi-footer-toggle {
                        pointer-events: none;
                        padding: 0;
                    }

                    .psi-footer-chevron {
                        display: none;
                    }

                    .psi-footer-list {
                        display: block;
                    }
                }
            `}</style>

            <footer className="psi-footer">
                <div className="psi-footer-grid">
                    <div className="psi-footer-brand">
                        <img
                            className="psi-footer-logo"
                            alt="Logo Psicopatici"
                            src="https://cdn.psicopaticiservice.com/logo/psi-v1-black-2.png"
                        />
                    </div>

                    {footerSections.map((section) => {
                        const isOpen = openSections.includes(section.title);

                        return (
                            <div key={section.title} className="psi-footer-col">
                                <h4>
                                    <button
                                        type="button"
                                        className="psi-footer-toggle"
                                        onClick={() => toggleSection(section.title)}
                                        aria-expanded={isOpen}
                                    >
                                        {section.title}
                                        <FiChevronDown
                                            className={`psi-footer-chevron ${isOpen ? 'is-open' : ''}`}
                                            aria-hidden="true"
                                        />
                                    </button>
                                </h4>
                                <ul
                                    className="psi-footer-list"
                                    style={{ display: isOpen ? 'block' : undefined }}
                                >
                                    {section.links.map((link) => (
                                        <li key={link.label}>
                                            <a
                                                href={link.href}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="psi-footer-link"
                                            >
                                                {link.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>

                <div className="psi-footer-bottom">
                    <p className="psi-footer-copy">
                        &copy; 2025 - {currentYear} All Rights Reserved by{' '}
                        <a href="https://www.psicopatici.com/">psicopatici.com</a>
                    </p>

                    <div className="psi-footer-social">
                        {socialLinks.map((social) => (
                            <a
                                key={social.label}
                                href={social.href}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {social.label}
                            </a>
                        ))}
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
